import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

//operation
import OrderListOperation from "./pages/operation/OrderListOperation";
import ManageOrderStatus from "./pages/operation/ManageOrderStatus";
import TerminationListOperation from "./pages/operation/TerminationListOperation";
import ManageTerminationStatus from "./pages/operation/ManageTerminationStatus";
import UploadCableData from "./pages/operation/UploadCableData";
import DataUploadList from "./pages/operation/DataUploadList";
import NotificationConfigurationList from "./pages/operation/NotificationConfigurationList";
import ManageEmailDestination from "./pages/operation/ManageEmailDestination";
import EmailDestinationList from "./pages/operation/EmailDestinationList";
import RegisterEmailDestination from "./pages/operation/RegisterEmailDestination";
import UpdateEmailDestination from "./pages/operation/UpdateEmailDestination";
import DeactivateEmailDestination from "./pages/operation/DeactivateEmailDestination";

//order
import OrderList from "./pages/order/OrderList";
import OrderDetail from "./pages/order/OrderDetail";
import OrderInput from "./pages/order/OrderInput";
import OrderUpdate from "./pages/order/OrderUpdate";
import OrderFeedback from "./pages/order/OrderFeedback";
import OrderApproval from "./pages/order/OrderApproval";
import CreateSalesOrder from "./pages/order/CreateSalesOrder";
import ViewSalesOrder from "./pages/order/ViewSalesOrder";

//quotation
import QuotationList from "./pages/quotation/QuotationList";
import CreateQuotation from "./pages/quotation/CreateQuotation";
import ViewQuotation from "./pages/quotation/ViewQuotation";
import UploadQuotation from "./pages/quotation/UploadQuotation";
import UploadPurchaseOrder from "./pages/quotation/UploadPurchaseOrder";
import UploadInstallation from "./pages/order/UploadInstallation";

//company
import CompanyList from "./pages/company/CompanyList";
import CompanyDetail from "./pages/company/CompanyDetail";
import InputCompany from "./pages/company/InputCompany";
import UpdateCompany from "./pages/company/UpdateCompany";

//customer
import CustomerList from "./pages/customer/CustomerList";
import CustomerDetail from "./pages/customer/CustomerDetail";
import CustomerInput from "./pages/customer/CustomerInput";
import CustomerUpdate from "./pages/customer/CustomerUpdate";
import CustomerSuspend from "./pages/customer/CustomerSuspend";

//account
import Profile from "./pages/account/Profile";
import ResetPassword from "./pages/account/ResetPassword";
import ChangePassword from "./pages/account/ChangePassword";
import LoginPage from "./pages/account/LoginPage";
import LogOutPage from "./pages/account/LogOutPage";
import Sidebar from "./component/Sidebar";
import ScrollToTop from "../src/component/ScrollToTop";
import Home from "./Home";

//termination
import TerminateOrder from "./pages/termination/TerminateOrder"
import UpdateTermination from "./pages/termination/UpdateTermination"
import TerminationList from "./pages/termination/TerminationList";
import TerminationDetail from "./pages/termination/TerminationDetail";
import CreateTerminationLetter from "./pages/termination/CreateTerminationLetter";
import TerminationFeedback from "./pages/termination/TerminationFeedback";
import UploadTerminationInstallation from "./pages/termination/UploadTerminationInstallation";


function App() {
  const location = useLocation();

  return (
    <div className="App">
      {location.pathname === "/login" ||
      location.pathname === "/reset-password" ? (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
      ) : (
        <div className="main">
          <Sidebar />
          <Routes>
            <Route path="/" element={<Home />} />

            {/* operation */}
            <Route path="/operation/order-list" element={<OrderListOperation />} />
            <Route path="/operation/manage-order-status" element={<ManageOrderStatus />} />
            <Route path="/operation/termination-list" element={<TerminationListOperation />} />
            <Route path="/operation/manage-termination-status" element={<ManageTerminationStatus />} />
            <Route path="/operation/upload-cable-data" element={<UploadCableData />} />
            <Route path="/operation/data-upload-list" element={<DataUploadList />} />
            <Route path="/operation/notification-configuration-list" element={<NotificationConfigurationList />} />
            <Route path="/operation/manage-email-destination" element={<ManageEmailDestination />} />
            <Route path="/operation/email-destination-list" element={<EmailDestinationList />} />  
            <Route path="/operation/register-email-destination" element={<RegisterEmailDestination />} />
            <Route path="/operation/update-email-destination" element={<UpdateEmailDestination />} />
            <Route path="/operation/deactivate-email-destination" element={<DeactivateEmailDestination />} />
            
            {/* order */}
            <Route path="/order-list" element={<OrderList />} />
            <Route path="/order-detail" element={<OrderDetail />} />
            <Route path="/input-order" element={<OrderInput />} />
            <Route path="/order-update" element={<OrderUpdate />} />           
            <Route path="/order-feedback" element={<OrderFeedback />} />
            <Route path="/order-approval" element={<OrderApproval />} />          
            <Route path="/create-sales-order" element={<CreateSalesOrder />} />
            <Route path="/view-sales-order" element={<ViewSalesOrder />} />
            <Route path="/upload-installation" element={<UploadInstallation />} />

            {/* quotation */}
            <Route path="/quotation-list" element={<QuotationList />} />
            <Route path="/create-quotation" element={<CreateQuotation />} />
            <Route path="/view-quotation" element={<ViewQuotation />} />
            <Route path="/upload-quotation" element={<UploadQuotation />} />          
            <Route path="/upload-purchase-order" element={<UploadPurchaseOrder />}/>
            
            {/* customer */}
            <Route path="/customer-list" element={<CustomerList />} />           
            <Route path="/customer-detail" element={<CustomerDetail />} />
            <Route path="/input-customer" element={<CustomerInput />} />
            <Route path="/update-customer" element={<CustomerUpdate />} />
            <Route path="/suspend-customer" element={<CustomerSuspend />} />

            {/* company */}
            <Route path="/company-list" element={<CompanyList />} />
            <Route path="/company-detail" element={<CompanyDetail />} />
            <Route path="/input-company" element={<InputCompany />} />
            <Route path="/update-company" element={<UpdateCompany />} />

            {/* termination */}
            <Route path="/termination-list" element={<TerminationList />}/>
            <Route path="/termination-detail" element={<TerminationDetail />}/>
            <Route path="/create-termination-letter" element={<CreateTerminationLetter />} />
            <Route path="/terminate-order" element={<TerminateOrder />}/>
            <Route path="/update-termination" element={<UpdateTermination />}/>
            <Route path="/termination-feedback" element={<TerminationFeedback />} />
            <Route path="/upload-termination-installation" element={<UploadTerminationInstallation />} />

            {/* account */}
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/log-out" element={<LogOutPage />} />
          </Routes>
        </div>
      )}
      <ScrollToTop />
    </div>
  );
}

export default App;
